<template>
    <div class="frames">
        <template v-if="frames && frames.length">
            <div class="frames-grid">
                <FrameCard
                    v-for="(frame, index) in frames"
                    :key="frame.external_id || frame.id || index"
                    :frame="frame"
                    :index="index"
                />
            </div>
        </template>
        <div v-else class="frames-empty">
            <span class="frames-empty__text">Инвентарей нет</span>
        </div>
    </div>
</template>

<script>
import FrameCard from './FrameCard.vue';

export default {
    name: 'FramesSection',
    components: {
        FrameCard,
    },
    props: {
        frames: {
            type: Array,
            default: () => [],
        },
    },
};
</script>

<style scoped>
.frames {
    margin-bottom: 20px;
}

.frames-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 12px;
}

.frames-empty {
    text-align: center;
    padding: 20px;
    color: var(--muted);
    font-style: italic;
}

.frames-empty__text {
    font-size: 14px;
}

/* Адаптивность */
@media (max-width: 768px) {
    .frames-grid {
        grid-template-columns: 1fr;
        gap: 8px;
    }
}
</style>
